import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Breadcrum from "../Components/Breadcrums/Breadcrum";
import ProductDisplay from "../Components/ProductDisplay/ProductDisplay";
import DescriptionBox from "../Components/DescriptionBox/DescriptionBox";
import RelatedProducts from "../Components/RelatedProducts/RelatedProducts";
import Measurement from "../Components/Measurement/Measurement";
import { useProductStore } from "../stores/useProductStores";

const Product = () => {
  const { productId } = useParams();
  const { selectedProduct, getProductById, loading } = useProductStore();

  useEffect(() => {
    getProductById(productId).catch(() => {});
  }, [getProductById, productId]);

  if (loading) return <div className="product-page-message">Loading product...</div>;
  if (!selectedProduct || Number(selectedProduct.id) !== Number(productId)) {
    return <div className="product-page-message">Product not found.</div>;
  }

  return (
    <div>
      <Breadcrum product={selectedProduct} />
      <ProductDisplay product={selectedProduct} />
      <DescriptionBox product={selectedProduct} />
      <Measurement />
      <RelatedProducts />
    </div>
  );
};

export default Product;
